import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "vendor/tempusdominus-bootstrap"

export default class extends Controller {
  connect() {
    this.initializePicker()
  }

  disconnect() {
    this.destroyPicker()
  }

  initializePicker() {
    this.$element = $(this.element)

    if (this.$element.data("datetimepicker")) {
      this.destroyPicker()
    }

    const format = this.element.dataset.datetimepickerFormat

    this.$element.on("blur.datetimePicker", () => {
      const picker = this.$element.data("datetimepicker")
      if (picker) {
        picker.hide()
      }
    })

    this.$element.datetimepicker({
      sideBySide: true,
      buttons: { showToday: true, showClear: true, showClose: true },
      format: format,
    })
  }

  destroyPicker() {
    if (this.$element) {
      this.$element.off(".datetimePicker")
      if (this.$element.data("datetimepicker")) {
        this.$element.datetimepicker("destroy")
      }
    }
  }
}
